import { render } from "./ControlName.vue?vue&type=template&id=4e15e657"
import script from "./ControlName.vue?vue&type=script&lang=js"
export * from "./ControlName.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__